import ekstraklasa384 from '../assets/images/cards/ekstraklasa-384.webp';
import ekstraklasa480 from '../assets/images/cards/ekstraklasa-480.webp';
import ekstraklasa768 from '../assets/images/cards/ekstraklasa-768.webp';
import ekstraklasa1152 from '../assets/images/cards/ekstraklasa-1152.webp';
import liga1384 from '../assets/images/cards/1liga-384.webp';
import liga1480 from '../assets/images/cards/1liga-480.webp';
import liga1768 from '../assets/images/cards/1liga-768.webp';
import liga11152 from '../assets/images/cards/1liga-1152.webp';
import liga2384 from '../assets/images/cards/2liga-384.webp';
import liga2480 from '../assets/images/cards/2liga-480.webp';
import liga2768 from '../assets/images/cards/2liga-768.webp';
import liga21152 from '../assets/images/cards/2liga-1152.webp';

const cardImage = (small, phone, medium, large) => ({
  src: small,
  srcSet: `${small} 384w, ${phone} 480w, ${medium} 768w, ${large} 1152w`,
});

export const leagueImages = {
  ekstraklasa: cardImage(ekstraklasa384, ekstraklasa480, ekstraklasa768, ekstraklasa1152),
  liga1: cardImage(liga1384, liga1480, liga1768, liga11152),
  liga2: cardImage(liga2384, liga2480, liga2768, liga21152),
};

export const LEAGUE_IMAGE_SIZES = '(min-width: 1200px) 240px, (min-width: 900px) 25vw, (min-width: 600px) 50vw, 100vw';
const publicUrl = process.env.PUBLIC_URL || '';
export const HOME_HERO_SMALL = `${publicUrl}/static/hero/home-hero-768.a9e9dd83bab2.webp`;
export const HOME_HERO_LARGE = `${publicUrl}/static/hero/home-hero-1200.6c866bcc9872.webp`;
export const HOME_HERO_SRC_SET = `${HOME_HERO_SMALL} 768w, ${HOME_HERO_LARGE} 1200w`;
// Must match the early, homepage-only preload in public/index.html.
export const HOME_HERO_SIZES = '(min-width: 1200px) calc(100vw - 700px), 100vw';
